import type { ProjectId } from 'owa-timestream-types';
import getProjectsInLocalStorage from './getProjectsInLocalStorage';
import { isFeatureEnabled } from 'owa-feature-flags';
import { default as setProjectInLocalStorage } from './setProjectInLocalStorage';

export default function getIsCanvasLockedFromLocalStorage(projectId: ProjectId): boolean {
    try {
        const { isCanvasLocked } = getProjectsInLocalStorage()[projectId];
        if (!isFeatureEnabled('cal-board-lockCanvas')) {
            if (isCanvasLocked) {
                setProjectInLocalStorage(projectId, { isCanvasLocked: false });
            }
            return false;
        }
        return typeof isCanvasLocked === 'boolean' && isCanvasLocked;
    } catch {}

    // by default assume false as to not block user actions
    return false;
}
